<template>
	<v-snackbar
		v-model="localIsVisible"
		:timeout="timeout"
		shaped
		centered
		color="#4CAF50"
		>{{ message }}
		<template v-slot:action="{ attrs }">
			<v-btn text v-bind="attrs" @click="onCancel">
				<v-icon>mdi-close-circle-outline</v-icon>
			</v-btn>
		</template>
	</v-snackbar>
</template>
<script>
export default {
	name: 'SnackbarMessage',
	props: {
		isVisible: Boolean,
		message: String,
		timeout: Number,
	},
	data() {
		return {
			localIsVisible: this.isVisible,
		};
	},
	watch: {
		isVisible(newVal) {
			this.localIsVisible = newVal;
		},
	},
	mounted() {
		if (!this.timeout) this.timeout = 3000;
	},
	methods: {
		onCancel() {
			this.localIsVisible = false;
			this.$emit('cancel');
		},
	},
};
</script>
